import { ToolsContent } from '@/api/interfaces/content/app/toolsContent';

export const toolsContent: ToolsContent = {
    stageContent: {
        icon: 'bleistift',
        heading: 'Tools',
    },
};
